import {Input} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {StyledDiscountFormItem} from "../styles/discount-form.styles";

export function DiscountCodeVariationFormFieldV2() {
  const {control} = useFormContext();
  return (
    <StyledDiscountFormItem>
      <div className="label-row">
        <label>Percentage off</label>
      </div>
      <Controller
        control={control}
        name="percentage_off"
        render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
          <>
            <Input
              status={error?.message ? "error" : ""}
              onChange={onChange}
              onBlur={onBlur}
              size="large"
              value={value}
              placeholder="Enter percentage"
              suffix="%"
              ref={ref}
            />
            {error && (
              <div role="alert" className="ant-form-item-explain-error">
                {error.message}
              </div>
            )}
          </>
        )}
      />
    </StyledDiscountFormItem>
  );
}
